/* @flow */

import * as React from 'react';
import styled from 'styled-components';

const Iconfont = styled.i`
  color: ${({ color }) => color};
  font-size: ${({ size }) => `${size}px`};
`;

export type Props = {
  type: string,
  size?: number,
  color?: string,
};

const Icon = ({
  type, size, color, ...others
}: Props) => (
  <Iconfont className={`iconfont icon-${type}`} size={size} color={color} {...others} />
);

Icon.defaultProps = {
  size: 16,
  color: '',
};

export default Icon;
